import state from './state/config';
import start from './dom';
import { reverseIndex } from './state/collection';
export { btmCopywritingPostProcessor } from './postProcessor';
export { baseValidation } from './metrics/validation';
function config(conf) {
    state.config = conf;
}
export default {
    start: start,
    config: config,
    getReverseIndex: function () { return reverseIndex; },
};
